import { useForm, usePage } from '@inertiajs/react';
import React from 'react';
import useRoute from '@/Hooks/useRoute';
import Button from '@/Components/Buttons/Button';
import FormSection from '@/Blocks/Forms/FormSection';
import Input from '@/Components/Inputs/Input';
import { useToasts } from '@/Hooks/toastContextProvider';
import InputSelectGroup from '@/Components/Inputs/InputSelectGroup';
import { router } from '@inertiajs/react';

export default function UpdateUserLinksInfomationForm({ user }) {
  const page = usePage();
  const route = useRoute();
  const { addToast } = useToasts();
  const categories = page.props.categories;

  const form = useForm({
    _method: 'POST',
    title: '',
    link_category_id: categories[0].id,
    url: '',
  });

  function addNewLink() {
    form.post(route('links.createProfileLink'), {
      errorBag: 'createProfileLink',
      preserveScroll: true,
      onSuccess: () => handleSuccess(),
    });
  }

  const handleSuccess = () => {
    router.visit(route('links.show'), {
      only: ['user'],
      preserveScroll: true,
    });

    addToast({ message: 'Link Added!', variant: 'success' });
  };

  return (
    <FormSection
      onSubmit={addNewLink}
      title={'New Link'}
      description={`Add your links to your madeby.studio social profile.`}
      renderActions={() => (
        <div className="col-span-2">
          <Button
            disabled={form.processing}
            type="submit"
            style="admin"
            variant="dark"
          >
            <p className="w-full text-lg text-white">Add New Link</p>
          </Button>
        </div>
      )}
    >
      {/* <!-- Link Title --> */}
      <div className="col-span-2 sm:col-span-1">
        <Input
          id="title"
          label="Link Title"
          type="text"
          value={form.data.title}
          onChange={e => form.setData('title', e.currentTarget.value)}
          error={form.errors.title}
        />
      </div>
      {/* <!-- Link Category --> */}
      <div className="col-span-2 sm:col-span-1">
        <InputSelectGroup
          id="link_category_id"
          options={categories}
          label="Link Category"
          type="text"
          onChange={e =>
            form.setData('link_category_id', e.currentTarget.value)
          }
          error={form.errors.link_category_id}
        />
      </div>
      {/* <!-- Link URL --> */}
      <div className="col-span-2">
        <Input
          id="url"
          label="Link URL"
          type="text"
          value={form.data.url}
          onChange={e => form.setData('url', e.currentTarget.value)}
          error={form.errors.url}
        />
      </div>
    </FormSection>
  );
}
